import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { NgxSuneditorComponent, NgxSuneditorModule } from "../../../../projects/ngx-suneditor/src/public-api";
import { SunEditorOptions } from 'suneditor/src/options';
import plugins from 'suneditor/src/plugins';
import { CollaboraEditorComponent } from '../../commons/collabora-editor/collabora-editor.component';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatDialog } from '@angular/material/dialog';
import { DlgDeleteComponent } from '../../commons/dlg-delete/dlg-delete.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DlgSignatureComponent } from '../../commons/dlg-signature/dlg-signature.component';
import { AppTitleService } from '../../services/app-title.service';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentType } from '../../models/DocumentType';
import { AuthService } from '../../services/auth.service';
import { DlgDestinoComponent } from './dlg-destino/dlg-destino.component';
import { FormControl, FormGroup, Validators, ReactiveFormsModule, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatTab, MatTabsModule } from '@angular/material/tabs';
import { ParticipantesType } from '../../models/ParticipantesType';
import { ParticipanteService } from '../../services/participante.service';
import { DlgAnexosComponent } from '../../commons/dlg-anexos/dlg-anexos.component';
import { Anexo, PostAnexosTemporalesResponse } from '../../models/Anexo';
import { DocumentoService } from '../../services/documento.service';
import { Documento, NumeracionDocumento, TramitePortal } from '../../models/Document';
import { DlgNumeracionComponent } from './dlg-numeracion/dlg-numeracion.component';
import { Participante } from '../../models/ParticipanteType';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import 'moment/locale/es';
import { AnexoService } from '../../services/anexo.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { FilesService } from '../../shared/files.service';
import { Location } from '@angular/common';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../commons/dlg-confirm/dlg-confirm.component';
import { ServidorPublico } from '../../models/ServidorPublico';
import { DlgAnexosTareaComponent } from '../../commons/dlg-anexos-tarea/dlg-anexos-tarea.component';
import { TareaService } from '../../services/tarea.service';
import { AnexosFullComponent } from "../../commons/anexos-full/anexos-full.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtilService } from '../../services/util.service';
import { DlgNumeroFlowComponent } from '../../commons/dlg-numero-flow/dlg-numero-flow.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatMenuModule } from "@angular/material/menu";
import { HttpErrorResponse } from '@angular/common/http';
import { WopiService } from '../../services/wopi.service';
import { Wopi } from '../../models/Wopi';
import { CollaboraMessageService } from '../../commons/collabora-editor/collabora-message.service';
import { EditorType } from '../../emuns/EditorType';
import { WopiAccion } from '../../emuns/WopiAccion';

export function participantesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const participantes: ParticipantesType = control.value;
    if (!participantes) {
      return { required: true }
    }
    if (!participantes.origen && !participantes.destino && !participantes.destinoBuzon) {
      return { requiredOrigen: true, requiredDestino: true }
    }
    if (!participantes.origen) {
      return { requiredOrigen: true }
    }
    if (!participantes.destino && !participantes.destinoBuzon) {
      return { requiredDestino: true }
    }

    if (participantes.origen.length <= 0 && participantes.destino.length <= 0 && participantes.destinoBuzon!.length <= 0) {
      return { requiredOrigen: true, requiredDestino: true }
    }
    if (participantes.origen.length <= 0) {
      return { requiredOrigen: true }
    }
    if (participantes.destino.length <= 0 && participantes.destinoBuzon!.length <= 0) {
      return { requiredDestino: true }
    }
    return null
  };
}

@Component({
  selector: 'app-nuevo',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  imports: [
    NgxSuneditorModule,
    CollaboraEditorComponent,
    MatCardModule,
    MatListModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    CapitalizePipe,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    AnexosFullComponent,
    MatAutocompleteModule,
    MatMenuModule
  ],
  templateUrl: './nuevo.component.html',
  styleUrls: ['./nuevo.component.scss']
})
export class NuevoComponent implements OnInit {

  utilService = inject(UtilService)
  public editorHasFocus: boolean = false;
  public fullscreenActive: boolean = false;
  @ViewChild(AnexosFullComponent) anexosFullComponent!: AnexosFullComponent;
  @ViewChild('collaboraEditorComponent') collaboraEditor?: CollaboraEditorComponent;
  @ViewChild(NgxSuneditorComponent) ngxSunEditor!: NgxSuneditorComponent;
   @ViewChild('tabCollabora') tabCollabora!: MatTab;
  editorOptions: SunEditorOptions = {
    minWidth: "100%",
    height: "50vh",
    plugins: plugins,
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["bold", "underline", "italic"],
      ["fontColor", "hiliteColor", "removeFormat"],
      ["outdent", "indent"],
      ["align", "list"],
      ["table"],
      //      ["codeView"]
    ],
    defaultStyle: "font-family: arial; font-size: 12px; text-align: justify;",
    font: ["Arial"],
    fontSize: [8, 10, 12],
    alignItems: ['justify']
  };

  // Collabora URL directa para iframe
  collaboraUrl: string = '';
  collaboraDocumentId: string = '';

  optTramites: any[] = [];
  @ViewChild('tramitePadreInput') tramitePadreInput: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('numeracionInput') numeracionInput: ElementRef<HTMLInputElement> | undefined;

  isEdit = this.route.snapshot.url[0].path === "editar";
  numeroFlow = new Date().getFullYear() + "-####";
  fetchingSubmitForm = false
  snackbarData: ScnackbarData = {}

  readOnlyNumeracion = true;
  documentID: string | null = null
  currentDocument: TramitePortal | Documento | null = null
  maxDate = new Date()

  participantes: ParticipantesType = {
    origen: [],
    destino: [],
    copia: [],
    destinoBuzon: []
  };
  usuarioAnterior?: String;

  anexos: Anexo[] = []
  documentTypes: DocumentType[] = []
  numeracionesDocumento: NumeracionDocumento[] = []

  defaultDocumentType = ""
  isPreview = false
  maxYear = "2024";

  tipoDocumentoSeleccionado: DocumentType | null = null
  numeracionDocumento?: NumeracionDocumento;
  newDocumentForm = new FormGroup({
    documentDate: new FormControl(new Date(), {
      validators: [Validators.required]
    }),
    tramitePadre: new FormControl<any>(null),
    documentType: new FormControl("", {
      validators: [Validators.required, Validators.pattern(/^[0-9]+$/)]
    }),
    category: new FormControl("", {
      validators: [Validators.required]
    }),
    numeracion: new FormControl("", {
      validators: [Validators.required]
    }),
    anioPadre: new FormControl(new Date().getFullYear().toString()),
    numeroPadre: new FormControl(),
    anio: new FormControl(this.maxYear.toString()),
    numero: new FormControl("0"),
    referenceNumber: new FormControl(""),
    tipificacion: new FormControl("", {
      validators: [Validators.required]
    }),
    asunto: new FormControl("", {
      validators: [Validators.required, Validators.maxLength(250)]
    }),
    participantes: new FormControl<ParticipantesType>(this.participantes, {
      validators: [
        participantesValidator(),
      ]
    }),
    cuerpo: new FormControl("contenido", {
      validators: []
    }),
    anexos: new FormControl<Anexo[]>(this.anexos),
  })
  tokenData = this.authService.getTokenData();

  hasParticipated = false;
  isOwner = false;
  anioActual = new Date().getFullYear();

  estadoTarea: number = -1
  EditorType = EditorType
  editor = signal<EditorType>(EditorType.odt);

  constructor(
    private documentoService: DocumentoService,
    private documentTypeService: DocumentTypeService,
    private participanteServ: ParticipanteService,
    private authService: AuthService,
    public dlg: MatDialog,
    public location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService,
    private cdr: ChangeDetectorRef,
    private dateService: DateService,
    private activatedRoute: ActivatedRoute,
    private anexosService: AnexoService,
    private appTitleService: AppTitleService,
    private filesService: FilesService,
    private tareaService: TareaService,
    private wopiService: WopiService
  ) {
  }

  ngOnInit(): void {
    this.documentID = this.activatedRoute.snapshot.paramMap.get("documentID")

    if (!this.documentID) {
      const userLogin = this.tokenData;
      if (userLogin) {
        this.participanteServ.getParticipanteServidorPublico().subscribe({
          next: (res: any[]) => {
            const currentParticipant = res.find((c: any) => c.ciruc === userLogin.sub) as any;
            if (currentParticipant) {
              let { fechaUso, ...res } = currentParticipant as ServidorPublico;
              const participante: Participante = {
                id: res.id.toString(),
                ciruc: res.ciruc,
                departamento: res.departamento,
                idTipoSolicitante: 1,
                nombres: new CapitalizePipe().transform((res.apellidos || '').trim() + " " + (res.nombres || '').trim()),
                cargo: res.cargo,
                titulo: res.titulo,
                institucion: '',
                portavoz: 0
              }
              this.participantes.origen.push(participante);
              this.newDocumentForm.controls.participantes.setValue(this.participantes)
              this.loadNumeracionDocumento()

              // Inicializar documento de Collabora - IMPORTANTE: debe ejecutarse

              this.wopiService.preparar(WopiAccion.nuevo).subscribe((wopi: Wopi) => {

                // Guardar el fileId para usarlo en la finalización
                this.collaboraDocumentId = wopi.id;

                // Construir la URL del iframe directamente
                this.collaboraUrl = wopi.url;

                // Forzar detección de cambios
                this.cdr.detectChanges();

              })
            }
          },
        });
      }

      this.loadDocumentTypes(null);
      this.newDocumentForm.controls.category.setValue("1")
      this.newDocumentForm.controls.tipificacion.setValue("0")
      this.appTitleService.setTitle("Nuevo Documento");
    } else {
      this.fetchDocumentByID();
    }
  }

  fetchDocumentByID() {
    this.documentoService.getById(parseInt(this.documentID!)).subscribe({
      next: (response: Documento) => {
        this.appTitleService.setTitle("Editar Documento: " + response.anio + "-" + response.numero);
        this.usuarioAnterior = response.usuarioAnterior;
        this.currentDocument = response

        this.utilService.getParticipacionUsuarioDocumento((this.currentDocument as Documento).id).subscribe({
          next: (_) => {
            this.hasParticipated = true
          },
          error: (_) => {
            this.hasParticipated = false
          }
        })

        if ((this.currentDocument as Documento).tipoAsignado === 1 && (this.currentDocument as Documento).participanteReasigna) {
          this.isOwner = (this.currentDocument as Documento).participanteReasigna.toString() == this.tokenData!.id
        } else {
          this.isOwner = (this.currentDocument as Documento).codigoParticipante.toString() == this.tokenData!.id
        }

        this.estadoTarea = (this.currentDocument as Documento).estadoTarea

        this.editor.set((this.currentDocument as Documento).editor? (this.currentDocument as Documento).editor : EditorType.html);

        this.loadCurrentDocumentData()

        this.loadAnexos()
      }
    })
  }

  loadCurrentDocumentData() {
    const date = this.dateService.parseDateString(this.currentDocument!.fecha as string)
    this.newDocumentForm.controls.documentDate.setValue(date)
    this.loadDocumentTypes(this.currentDocument!.tipoDocumento.descripcion)
    this.newDocumentForm.controls.documentDate.setValue(new Date(this.currentDocument!.fecha))
    this.checkAndSetDocumentDateOnExtemporalSelectedDate(this.newDocumentForm.controls.documentDate.value!)
    this.newDocumentForm.controls.category.setValue(this.currentDocument!.categoria.toString())
    this.newDocumentForm.controls.numeracion.setValue(this.currentDocument!.numeroDocumento)
    this.newDocumentForm.controls.referenceNumber.setValue(this.currentDocument!.numeroReferencia)
    this.newDocumentForm.controls.asunto.setValue(this.currentDocument!.asunto)
    this.newDocumentForm.controls.tipificacion.setValue(this.currentDocument!.tipificacion.toString())
    this.newDocumentForm.controls.cuerpo.setValue(this.currentDocument!.cuerpo)
    if (this.currentDocument!.tramitePadre) {
      this.newDocumentForm.controls.anioPadre.setValue(this.currentDocument!.tramitePadre.anio);
      this.newDocumentForm.controls.numeroPadre.setValue(this.currentDocument!.tramitePadre.numero);
      this.newDocumentForm.controls.tramitePadre.setValue(this.currentDocument!.tramitePadre)
      this.optTramites = [this.currentDocument!.tramitePadre];
    }

    if (this.currentDocument!.editor == EditorType.odt) {

      this.wopiService.preparar(WopiAccion.editar, this.currentDocument!.idTarea).subscribe((wopi: Wopi) => {
        this.collaboraDocumentId = wopi.id;
        this.collaboraUrl = wopi.url;
        this.cdr.detectChanges();
      })

    } else {
        this.currentDocument!.editor = EditorType.html;
        this.cdr.detectChanges();

        this.ngxSunEditor.setContents(this.currentDocument!.cuerpo);
    }

    this.participantes.origen = this.currentDocument!.de as Participante[]
    this.participantes.destino = this.currentDocument!.para
    this.participantes.destinoBuzon = this.currentDocument!.buzonesPara ? this.currentDocument!.buzonesPara : []
    this.participantes.copia = this.currentDocument!.cc ? this.currentDocument!.cc : []
    this.newDocumentForm.controls.participantes.setValue(this.participantes)
  }

  numeroDwf = false;
  isNumeracionManual = false;
  showNumeracion() {
    if (this.isTramitePadre) {
      this.isTramitePadre = false;
      this.isNumeracionManual = true
      return
    }
    this.isNumeracionManual = !this.isNumeracionManual
    //this.newDocumentForm.controls.numero.setValue("0");
    //this.newDocumentForm.controls.anio.setValue(this.maxYear.toString());
  }

  isTramitePadre = false
  showTramitePadre() {
    if (this.isNumeracionManual) {
      this.isNumeracionManual = false;
      this.isTramitePadre = true
      return
    }
    this.isTramitePadre = !this.isTramitePadre
    //this.newDocumentForm.controls.numero.setValue("0");
    //this.newDocumentForm.controls.anio.setValue(this.maxYear.toString());
  }

  loadAnexos() {
    const idTarea = (this.currentDocument as Documento | null)?.idTarea;
    const request$ = (this.isEdit && idTarea)
      ? this.anexosService.getAnexosRamal(idTarea)
      : this.anexosService.listAnexosByDocumentID(parseInt(this.documentID!));

    request$.subscribe({
      next: (response) => {
        this.anexos = response
        this.newDocumentForm.controls.anexos.setValue(this.anexos)
        if (this.isPreview) {
          this.isPreview = false
          this.openDlgSign()
        }
      }
    })
  }

  loadDocumentTypes(documentTypeDescription: string | null) {
    if (!documentTypeDescription) {
      documentTypeDescription = "Oficio"
    }
    this.documentTypeService.list().subscribe({
      next: (response: DocumentType[]) => {
        this.documentTypes = response;
        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);
        if (defaultType) {
          this.tipoDocumentoSeleccionado = defaultType
          this.defaultDocumentType = defaultType.id.toString();

          this.newDocumentForm.controls.documentType.setValue(this.defaultDocumentType);
        }
        this.cdr.detectChanges();
      }
    });
  }

  manageChangedDocumentDate(event: MatDatepickerInputEvent<any>) {
    if (!event.value) {
      return
    }
    const selectedDate = new Date(event.value._d)
    this.checkAndSetDocumentDateOnExtemporalSelectedDate(selectedDate)
  }

  checkAndSetDocumentDateOnExtemporalSelectedDate(selectedDate: Date) {
    const currentDate = new Date()

    if (selectedDate.getDate() < currentDate.getDate()) {
      this.newDocumentForm.controls.category.setValue("0")
      this.newDocumentForm.controls.category.disable()
    } else {
      this.newDocumentForm.controls.category.setValue("1")
      this.newDocumentForm.controls.category.enable()
    }
  }

  manageChangedDocumentType(event: MatSelectChange) {
    const selectedDocumentType = this.documentTypes.find((type) => type.id == event.value)
    this.tipoDocumentoSeleccionado = selectedDocumentType!
    if (this.isEdit) return
    if (this.numeracionDocumento) {
      this.setNumeracion(this.numeracionDocumento?.numeracion)
    } else {
      if (this.newDocumentForm.controls.numeracion.value) {
        var valor = this.newDocumentForm.controls.numeracion.value;
        var num = this.newDocumentForm.controls.numeracion.value.substring(0, valor.length - 3)
        num = num + "-" + this.tipoDocumentoSeleccionado!.descripcion.substring(0, 2).toUpperCase()
        this.newDocumentForm.controls.numeracion.setValue(num);
      }
    }
  }

  onCollaboraReady() {
  }

  onFullscreen(): void {
    this.fullscreenActive = true;
    this.collaboraEditor?.enterFullscreen();
  }

  onEditorFocus(focused: boolean): void {
    if (focused) this.editorHasFocus = true;
  }

  onCollaboraContentChanged() {
    // El documento se guarda automáticamente en Collabora

  }

  /**
   * Envía un postMessage al iframe de Collabora para forzar guardado (Action_Save).
   * Puede invocarse desde un botón externo.
   */
  sendCollaboraSaveCommand(): void {
    if (this.editor() === EditorType.odt && this.collaboraEditor && typeof (this.collaboraEditor as any).saveAndWait === 'function') {
      console.log('Usando collaboraEditor.saveAndWait() para guardar...');
      (this.collaboraEditor as any).saveAndWait().then(() => {
        console.log('Guardado completado via saveAndWait()');
      }).catch((err: any) => {
        console.error('Error en saveAndWait():', err);
      });
      return;
    }
  }

  onCollaboraError(error: string) {
    this.toast.show({
      style: SnackbarStyles.Error,
      message: error
    });
  }

  manageEditorContentChange(event: { content: string; core: unknown }) {
    this.newDocumentForm.controls.cuerpo.setValue(event.content)
    this.cdr.detectChanges()
  }

  loadNumeracionDocumento() {
    this.documentoService.getNumeracion(this.tokenData?.id).subscribe({
      next: (response) => {
        this.numeracionesDocumento = response
        if (this.isEdit) return
      }
    })
  }


  setCuerpoDocumento() {
    const cuerpo = `<p>De mi consideración: </p>
     <br>`
    this.newDocumentForm.controls.cuerpo.setValue(cuerpo)
    this.ngxSunEditor.setContents(cuerpo)
  }

  onEditConfirm() {
    const data: DlgConfirmComponentData = {
      title: "Editar numeraci\u00f3n?",
      message: "¿Est\xe1 seguro de continuar?",
      confirmLabel: "Si, continuar",
      closeLabel: "No"
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.readOnlyNumeracion = false;
        this.newDocumentForm.controls.numeracion.setValue("");
        this.numeracionInput?.nativeElement.focus();
      }
    });
  }

  onDlgNumeracion() {
    const dialogRef = this.dlg.open(DlgNumeracionComponent, {
      data: this.participantes.origen.at(0)!.id
    });
    dialogRef.afterClosed().subscribe((result: any | undefined) => {
      if (result && result.id) {
        this.numeracionesDocumento = result
        this.setNumeracion(result.numeracion);
        this.readOnlyNumeracion = true;
      } else if (result === 1) {
        this.onEditConfirm();
      }
    });
  }

  setNumeracion(numeracion: string = "") {
    this.newDocumentForm.controls.numeracion.setValue(numeracion);
    var numeracion = numeracion.replace("{ANIO}", new Date().getFullYear().toString());
    numeracion = numeracion.replace("{NUMERO}", "####");
    numeracion = numeracion.replace("{TIPO}", this.tipoDocumentoSeleccionado!.descripcion.substring(0, 2).toUpperCase());
    this.newDocumentForm.controls.numeracion.setValue(numeracion);
  }

  async submitNewDocumentForm() {

    this.fetchingSubmitForm = true;

    if (this.editor() === EditorType.odt && this.collaboraEditor) {
      await this.collaboraEditor?.saveAndWait();
    }

    const formControls = this.newDocumentForm.controls
    const numeroFlow = parseInt(formControls.numero.value!);
    const anexosMencionados = this.getAnexosMencionados();

    const newDocument: TramitePortal = {
      id: this.documentID ? parseInt(this.documentID) : 0,
      anio: numeroFlow || numeroFlow > 0 ? parseInt(formControls.anio.value!) : 0,
      numero: numeroFlow || numeroFlow > 0 ? parseInt(formControls.numero.value!) : 0,
      tipoDocumento: parseInt(formControls.documentType.value!),
      tipoSolicitante: 1,
      categoria: parseInt(formControls.category.value!),
      tipificacion: parseInt(formControls.tipificacion.value!),
      fecha: this.dateService.formatDateToCustomString(formControls.documentDate.value!),
      numeroDocumento: formControls.numeracion.value! || '',
      numeroReferencia: formControls.referenceNumber.value! || '',
      asunto: formControls.asunto.value! || '',
      cuerpo: formControls.cuerpo.value! || '',
      anexos: formControls.anexos.value! || [],
      de: formControls.participantes.value!.origen || [],
      para: formControls.participantes.value!.destino || [],
      cc: formControls.participantes.value!.copia || [],
      idMemo: 0,
      idAnexo: 0,
      anexosMencionados,
      buzonesPara: formControls.participantes.value!.destinoBuzon,
      idTramitePadre: formControls.tramitePadre.value?.idTramite ? parseInt(formControls.tramitePadre.value.idTramite) : 0,
      editor: this.editor(),
      collaboraId: this.collaboraDocumentId
    }

    if (!this.documentID) {

      this.documentoService.postTramite(newDocument).subscribe(({
        next: async (response: TramitePortal) => {

          this.snackbarData.message = "Documento creado!"
          this.snackbarData.style = SnackbarStyles.Success
          this.snackbarData.iconName = "check_circle"
          this.toast.show(this.snackbarData)

          this.utilService.callTasks();
          if (this.isPreview) {
            this.fetchingSubmitForm = false
            this.documentID = response.id!.toString()
            this.fetchDocumentByID()
          } else {
            this.fetchingSubmitForm = false
            this.openDlgNumeroFlow(response.id!, `${response.anio}-${response.numero}`, response.numeroDocumento)
          }
        },
        error: (err: HttpErrorResponse) => {                    
            this.snackbarData.message = err.error;
            this.snackbarData.style = SnackbarStyles.Error
            this.snackbarData.iconName = "error"
            this.fetchingSubmitForm = false
            this.toast.show(this.snackbarData)
        }
      }))
    } else {
      this.documentoService.patchTramite(newDocument).subscribe({
        next: async (response) => {
          this.snackbarData.message = "Documento guardado"
          this.snackbarData.iconName = "check_circle"
          this.toast.show(this.snackbarData)
          if (this.isPreview) {
            this.fetchingSubmitForm = false
            if (this.collaboraEditor && typeof (this.collaboraEditor as any).preview === 'function') {
              try {
                // Construir payload similar al de finalize para que la vista previa tenga datos de plantilla
                const formControls = this.newDocumentForm.controls;
                const participantes = formControls.participantes.value!;
                const paraTitulos = participantes.destino.map((p: any) => p.titulo || '');
                const paraNombres = participantes.destino.map((p: any) => p.nombres);
                const paraCargos = participantes.destino.map((p: any) => p.cargo || '');
                const deTitulos = participantes.origen.map((p: any) => p.titulo || '');
                const deNombres = participantes.origen.map((p: any) => p.nombres);
                const deCargos = participantes.origen.map((p: any) => p.cargo || '');
                const ccNombres = participantes.copia.map((p: any) => p.nombres);
                const ccTitulos = participantes.copia.map((p: any) => p.titulo || '');

                // Usar numeroDocumento del servidor si está disponible
                const numeroFlow = response ? `${response.anio}-${response.numero}` : '';
                const numeroCompleto = response?.numeroDocumento && numeroFlow
                  ? `${response.numeroDocumento} / ${numeroFlow}`
                  : response?.numeroDocumento || formControls.numeracion.value || '';
                const numeroBase = response?.numeroDocumento || formControls.numeracion.value || '';

                const payload = {
                  fileId: this.collaboraDocumentId,
                  TIPO_DOCUMENTO: this.tipoDocumentoSeleccionado?.descripcion || '',
                  NUMERO_TMP: this.collaboraDocumentId,
                  NUMERO_DOCUMENTO: numeroBase,
                  FECHA: (formControls.documentDate.value as Date).toISOString(),
                  ASUNTO: formControls.asunto.value || '',
                  TIPIFICACION: formControls.tipificacion.value || '0',
                  PARA_TITULO: paraTitulos.join(';'),
                  PARA_NOMBRES: paraNombres.join(';'),
                  PARA_CARGO: paraCargos.join(';'),
                  DE_TITULO: deTitulos.join(';'),
                  DE_NOMBRES: deNombres.join(';'),
                  DE_CARGO: deCargos.join(';'),
                  REFERENCIAS: formControls.referenceNumber.value || '',
                  ANEXOS: (anexosMencionados ?? []).join(';'),
                  CC_NOMBRES: ccNombres.join(';'),
                  CC_TITULO: ccTitulos.join(';'),
                  RESPONSABLE: this.tokenData?.name || '',
                  ES_RESPUESTA: '',
                  CODIGO_MOVTAREA: response && response.id ? String(response.id) : ''
                };

                await (this.collaboraEditor as any).preview(payload);
              } catch (e) {
                console.error('Error al generar vista previa desde Collabora:', e);
                this.documentID = response.id!.toString();
                this.fetchDocumentByID();
              }
            } else {
              this.documentID = response.id!.toString()
              this.fetchDocumentByID()
            }
          } else {
            this.fetchingSubmitForm = false
            this.openDlgNumeroFlow(response.id!, `${response.anio}-${response.numero}`, response.numeroDocumento)
          }
        },
        error: (error) => {
          this.snackbarData.message = "Error actualizado documento!"
          this.snackbarData.style = SnackbarStyles.Error
          this.snackbarData.iconName = "error"
          this.fetchingSubmitForm = false
          this.toast.show(this.snackbarData)
        }
      })
    }
  }

  openDlgSignAnexo(anexoID: number) {
    if (this.isEdit) {
      this.router.navigateByUrl(`/firmarAnexo/${this.documentID}/${anexoID}/editar`)
    }
  }

  checkAnexoPDF(anexoID: number) {
    const name = this.anexos.find((anexo) => anexo.id === anexoID)?.nombre
    const extension = name?.slice(name.length - 3, name.length)
    if (extension === "pdf") {
      return true
    }
    return false
  }

  getAnexosMencionados(): number[] | undefined {
    if (this.anexosFullComponent) {
      return this.anexosFullComponent.getAnexosMencionadosIds();
    }
    // En creacion inicial no existe selector aun: undefined => backend usa anexos por defecto.
    return undefined;
  }

  openDlgNumeroFlow(id: number, numeroFlow: string, numeroDocumento: string) {
    const dialogRef = this.dlg.open(DlgNumeroFlowComponent, {
      data: { numeroFlow: numeroFlow, numeroDocumento: numeroDocumento }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.router.navigateByUrl("/finalizar/" + id);
    });
  }

  onDeleteAnexo(id: number) {
    const dlgDelete = this.dlg.open(DlgDeleteComponent, {
      width: '350px',
    });

    dlgDelete.afterClosed().subscribe(result => {
      if (result === 1) {
        this.anexos = this.anexos.filter((anexo) => anexo.id !== id);
        this.snackbarData.message = "Anexo eliminado!"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.toast.show(this.snackbarData)
      } else {
        this.snackbarData.message = "Error eliminando anexo!"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData)
      }
    });
  }

  openDlgDestino() {
    const dlgDestino = this.dlg.open(DlgDestinoComponent, {
      width: '80vw',
      maxWidth: '80vw',
      data: this.participantes
    });

    dlgDestino.afterClosed().subscribe(result => {
      if (result) {
        this.participantes = result;
        this.newDocumentForm.controls.participantes.setValue(this.participantes)
        if (!this.documentID) {
          this.loadNumeracionDocumento()
        }
      }
    });
  }

  openDlgSign() {
    const dlgSign = this.dlg.open(DlgSignatureComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {
        firmar: 0,
        idAnx: this.anexos.find((anexo) => anexo.tipo === 0)!.id
      },
    });

    dlgSign.afterClosed().subscribe(result => {
      if (this.documentID) {
        this.isEdit = true;
        this.appTitleService.setTitle("Editar Documento");
      }

    })
  }

  openDlgAnexos() {
    const dlgDestino = this.dlg.open(DlgAnexosComponent, {
      panelClass: "anexos-panel"
    });

    dlgDestino.afterClosed().subscribe((result: PostAnexosTemporalesResponse[] | undefined) => {
      if (result !== undefined) {
        this.anexos.push(...result);
        this.newDocumentForm.controls.anexos.setValue(this.anexos)
      }
    });
  }

  openDlgAnexosFijo() {
    const dlgDestino = this.dlg.open(DlgAnexosTareaComponent, {
      panelClass: "anexos-panel",
      data: this.documentID
    });

    dlgDestino.afterClosed().subscribe((result: Anexo[] | undefined) => {
      if (result !== undefined) {
        result.forEach((anexo) => {
          const exists = this.anexos.some(existingAnexo => existingAnexo.id === anexo.id);
          if (!exists) {
            this.anexos.push(anexo);
          }
        });
      }
    });
  }

  onDeleteAnexoFijo(id: number) {
    const dlgDelete = this.dlg.open(DlgDeleteComponent, {
      width: '350px',
    });

    dlgDelete.afterClosed().subscribe(result => {
      if (result === 1) {
        this.tareaService.deleteAnexoTarea(id).subscribe({
          next: (_) => {
            this.anexos = this.anexos.filter((anexo) => anexo.id !== id);
            this.snackbarData.message = "Anexo eliminado!"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "check_circle"
            this.toast.show(this.snackbarData)
          }
        })
      }
    });
  }

  openAnexo(anexoID: number) {
    const anexoType = this.anexos.find((anexo) => anexo.id === anexoID)?.estatus
    this.anexosService.getAnexoByID(anexoID, anexoType!).subscribe({
      next: (response) => {
        this.filesService.openFileFromOctectStream(response)
      },
      error: (error) => {
        console.error('Error downloading the anexo', error);
      }
    });
  }

  buscarDocumentoPadre(anio: string, numero: string) {
    this.documentoService.getDocumentos(anio, numero).subscribe({
      next: (response) => {
        if (response.length > 0) {
          this.optTramites = response;
          this.tramitePadreInput!.nativeElement.focus();
        } else {
          this.newDocumentForm.controls.tramitePadre.setValue(null);
          this.toast.show({
            message: "No se encontr\xf3 el documento padre",
            style: SnackbarStyles.Warning,
            iconName: "warning"
          });
        }
      },
      error: (error) => {
        console.error('Error downloading the anexo', error);
      }
    });
  }

  downloadAnexo(anexoID: number) {
    const anexoType = this.anexos.find((anexo) => anexo.id === anexoID)?.estatus
    this.anexosService.getAnexoByID(anexoID, anexoType!).subscribe({
      next: (response) => {
        this.filesService.openFileFromOctectStream(response, true)
      },
      error: (error) => {
        console.error('Error downloading the anexo', error);
      }
    });
  }

  displayFn(data: any): string {
    return data && data.descripcion ? data.descripcion : '';
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }

}
